export interface Endorsement {
  /** The endorsement quote */
  quote: string;
  /** Display name */
  name: string;
  /** Professional title, e.g. "Sex Therapist" */
  title: string;
  /** Optional credential line, e.g. "PhD, AASECT Certified" */
  credential?: string;
  /** Path to headshot image in /public/img/endorsements/. Falls back to initials when missing. */
  image?: string;
}

/**
 * Consensus copy shown above the endorsement cards on the landing page.
 * Keep this as the broad section-level summary that introduces the cards below.
 */
export const EXPERT_CONSENSUS =
  'Created with sexologists and relationship therapists to make one of the most important conversations in a relationship easier, safer, and more fun.';

/**
 * Individual endorsement cards rendered on the landing page.
 * Images live under /public/img/endorsements/ and fall back to initials when unavailable.
 */
export const ENDORSEMENTS: Endorsement[] = [
  {
    quote:
      'Playfulness matters. When intimacy feels lighter and more inviting, couples are often more open to curiosity, exploration, and discovering what they both want more of.',
    name: 'Dr. Elin Noorlander',
    title: 'Clinical Sexologist',
    credential: 'PhD',
    image: '/img/endorsements/Endorsement1.jpg',
  },
  {
    quote:
      'I recommend this format not just to my clients, but to any couple. It gives couples a comfortable way into a conversation that can genuinely deepen connection.',
    name: 'Marius van Leemput',
    title: 'Relationship Therapist',
    credential: 'MSc',
    image: '/img/endorsements/Endorsement2.jpg',
  },
];

export const HERO_EXPERT_TRUST_LABEL =
  'Created with sexologists & relationship therapists';

export const HERO_EXPERT_TRUST_PORTRAITS = ENDORSEMENTS.slice(0, 2).map((endorsement) => ({
  name: endorsement.name,
  image: endorsement.image,
}));
